import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate, formatTime, useTimeFormat } from "helpers/timeFormat";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleNotifsPaginate } from "store/players/list/slice";
import { playersListLimits } from "configs/limits";

import Pagination from "components/Pagination";
import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";
import styles from "./ListInfo.module.scss";

interface Props {
  limit: number;
  onLimitChange: (limit: number) => void;
}

const ListInfoTable: React.FC<Props> = ({ limit, onLimitChange }) => {
  const timeFormat = useTimeFormat();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const notifsList = useAppSelector((store) => store.players.notifsList);
  const totalItems = useAppSelector((store) => store.players.totalItemsNotifs);
  const totalPages = useAppSelector((store) => store.players.totalPagesNotifs);
  const activePage = useAppSelector((store) => store.players.activePageNotifs);
  const isNotifsFetched = useAppSelector(
    (store) => store.players.isNotifsFetched,
  );

  if (!isNotifsFetched) return <ModalTabSkeleton />;

  const handlePrevClick = () => {
    if (activePage > 1) {
      dispatch(handleNotifsPaginate(activePage - 1));
    }
  };
  const handleNextClick = () => {
    if (activePage !== totalPages) {
      dispatch(handleNotifsPaginate(activePage + 1));
    }
  };

  return (
    <div
      className={`${styles.playerInfoNotifications} player-inner-content-wrapper`}
    >
      <div className="inner-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>{t("title")}</th>
              <th>{t("content")}</th>
              <th>{t("status")}</th>
              <th>{t("sent")}</th>
            </tr>
          </thead>
          <tbody>
            {notifsList.map((el) => (
              <tr key={el.title}>
                <td>{el.title}</td>
                <td className="big-text">{el.content}</td>
                <td>
                  <div
                    className={`active-label ${el.isChecked ? "active" : ""}`}
                  >
                    {el.isChecked ? t("read") : t("unread")}
                  </div>
                </td>
                <td className="date">
                  <span>{formatDate(el.created)}</span>
                  <span>{formatTime(el.created, timeFormat)}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        activePage={activePage}
        limit={limit}
        totalItems={totalItems}
        totalPages={totalPages}
        limitsArray={playersListLimits}
        handleLimitClick={(nextLimit) => {
          onLimitChange(nextLimit);
          dispatch(handleNotifsPaginate(1));
        }}
        handleNextClick={handleNextClick}
        handlePrevClick={handlePrevClick}
      />
    </div>
  );
};

export default ListInfoTable;
